import { render } from "./PosClaimInvoices.vue?vue&type=template&id=330382d6"
import script from "./PosClaimInvoices.vue?vue&type=script&lang=js"
export * from "./PosClaimInvoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__